export const GET_QUOTES = 'GET_QUOTES';
export const SET_QUOTES = 'SET_QUOTES';
export const ADD_QUOTE = 'ADD_QUOTE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const DELETE_QUOTE = 'DELETE_QUOTE';
